import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import AsyncButton from './AsyncButton';

export type ModalSize = "sm" | "lg" | "xl";

interface ModalProps {
    title: string;
    onAdvance: AdvanceCallback;
    onCancel(): void;
    async?: boolean;
    advanceButtonText?: string;
    isAdvanceButtonDisabled?: boolean;
    cancelButtonText?: string;
    isCancelButtonDisabled?: boolean;
    backButtonText?: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    hideFooter?: boolean;
    size?: ModalSize;
    centered?: boolean;
    className?: string;
    allowClickOff?: boolean;
}

type AdvanceCallback = (() => void) | (() => Promise<void>);

const ModalWrapper: React.FC<ModalProps> = props => {
    return <Modal show size={props.size}
        onHide={props.onCancel}
        backdrop={props.allowClickOff ? true : "static"}
        centered={props.centered}
        className={props.className}>
        <Modal.Header closeButton>
            <Modal.Title>
                {props.title}
            </Modal.Title>
        </Modal.Header>

        <Modal.Body>
            {props.children}
        </Modal.Body>
        {props.hideFooter !== true && <Modal.Footer>
            {props.footer ?? <StandardFooter {...props} />}
        </Modal.Footer>}
    </Modal>
}

const StandardFooter: React.FC<ModalProps> = React.memo(props => {
    return <>
        <Button variant="secondary" onClick={props.onCancel} disabled={props.isCancelButtonDisabled}>
            {props.cancelButtonText ?? "Cancel"}
        </Button>
        <SaveButton onClick={props.onAdvance}
            isDisabled={props.isAdvanceButtonDisabled}
            text={props.advanceButtonText}
            async={props.async} />
    </>;
})

interface SaveButtonProps {
    isDisabled?: boolean;
    onClick: AdvanceCallback;
    text: string;
    async?: boolean;
}

export const SaveButton: React.FC<SaveButtonProps> = React.memo(props => {

    return (props.async === true)
        ? <AsyncButton disabled={props.isDisabled} onClickAsync={props.onClick as (() => Promise<void>)}>
            {props.text ?? "Save"}
        </AsyncButton>
        : <Button disabled={props.isDisabled} variant="primary" onClick={props.onClick}>
            {props.text ?? "Save"}
        </Button>
})

export default ModalWrapper;